import { useTranslation } from 'react-i18next'

import { useDateLocale, useTimeZone } from '../../../../hooks'
import Text from '../../../Text'
import { formatEntityProfileTabUpdateCardTimestamp } from '../EntityProfileTabUpdates.utils'
import { EntityProfileTabUpdatesCardOwnerName } from '../EntityProfileTabUpdatesCardOwnerName'

import { getEntityProfileTabUpdateDisplayName } from './EntityProfileTabUpdatesCardHeader.utils'

import * as styles from './EntityProfileTabUpdatesCardHeader.module.css'

function EntityProfileTabUpdatesCardHeader({
  deletedOwnerNameKey,
  isInteractive,
  owner,
  systemOwnerNameKey,
  timestamp,
  type,
}) {
  const { t } = useTranslation()

  const locale = useDateLocale()
  const timeZone = useTimeZone()

  const displayName = getEntityProfileTabUpdateDisplayName({
    deletedOwnerNameKey,
    owner,
    systemOwnerNameKey,
    t,
    type,
  })

  const formattedTimestamp = timestamp
    ? formatEntityProfileTabUpdateCardTimestamp({
        locale,
        timestamp,
        timeZone,
      })
    : null

  return (
    <div className={styles.EntityProfileTabUpdatesCardHeader}>
      <EntityProfileTabUpdatesCardOwnerName
        isInteractive={isInteractive}
        name={displayName}
        owner={owner}
      />
      {formattedTimestamp ? (
        <Text isSecondary className={styles.timestamp}>
          {formattedTimestamp}
        </Text>
      ) : null}
    </div>
  )
}

export default EntityProfileTabUpdatesCardHeader
